import { render, staticRenderFns } from "./AlphabetSystemQuizView.vue?vue&type=template&id=06f75412&scoped=true&"
import script from "./AlphabetSystemQuizView.vue?vue&type=script&lang=js&"
export * from "./AlphabetSystemQuizView.vue?vue&type=script&lang=js&"
import style0 from "./AlphabetSystemQuizView.vue?vue&type=style&index=0&id=06f75412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f75412",
  null
  
)

export default component.exports